import { AuthProvider } from "@khazzin/auth";
import { applyDocumentLocale, storedLocale } from "@khazzin/i18n";
import { reloadOnStaleChunk } from "@khazzin/ui/patterns/staleChunk";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "@khazzin/ui/index.css";

// A tab that outlived a deploy reloads once onto the new build rather than
// failing the first screen it lazy-loads (ADJ-1016-8).
reloadOnStaleChunk();

const container = document.getElementById("root");
if (container === null) {
	throw new Error("index.html is missing its #root element");
}

// Validated before anything renders, as the Admin Console does: a missing
// client id is one loud error at startup rather than a broken sign-in later.
const clientId = import.meta.env.VITE_WORKOS_CLIENT_ID;
const redirectUri = import.meta.env.VITE_WORKOS_REDIRECT_URI;
if (!clientId || !redirectUri) {
	throw new Error(
		"VITE_WORKOS_CLIENT_ID and VITE_WORKOS_REDIRECT_URI must both be set. " +
			"Copy web/apps/store/.env.example to web/apps/store/.env.local and fill them in.",
	);
}

// Direction before the first paint, from what this browser last chose.
applyDocumentLocale(storedLocale());

createRoot(container).render(
	<StrictMode>
		<AuthProvider
			interface="store"
			clientId={clientId}
			redirectUri={redirectUri}
			apiHostname={import.meta.env.VITE_WORKOS_API_HOSTNAME}
		>
			<App />
		</AuthProvider>
	</StrictMode>,
);
